
import { useLocation, useNavigate } from 'react-router-dom';
import '../App.css';
import { BackgroundStyle, BigHeading, LightBlueContainer, ShortBlueButton } from '../assets/style';
import MainContent from '../components/MainContent';
import RecordTable, { TableHeader } from '../components/RecordTable';
import { projectPageName } from '../components/PageName';
import { useLazyGetScheduleListingQuery } from '../features/schedule/scheduleSlice';
import { useEffect, useState } from 'react';
import RecordTableV2 from '../components/RecordTableV2';
import { RecordModel } from '../models/RecordModel';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { selectPermissions } from '../features/auth/authSlice';
import { Permissions } from '../utils/Permissions';

const WorkSchedulePage = () => {
    const { t, i18n } = useTranslation();
    // const getLocation = useLocation();
    // // const entry = getLocation.state?.entry;
    // // console.log(entry)
    // const projectId = getLocation.state;
    const getLocation = useLocation();
    var project = getLocation?.state?.project;
    var position = getLocation?.state?.position;
    // console.log("project,", project)
    // console.log("position,", position)
    const navigate = useNavigate();
    const [getScheduleListQuery] = useLazyGetScheduleListingQuery();
    const columns: TableHeader[] = [
        // { field: 'id', headerName: 'Schedule Id', width: 400, isSortable: true },
        { field: 'date', headerName: t('Date'), width: 250, isSortable: true },
        { field: 'scheduleStartTime', headerName: t('Schedule Start Time'), width: 250, isSortable: true },
        { field: 'scheduleEndTime', headerName: t('Schedule End Time'), width: 250, isSortable: true },
        { field: 'status', headerName: t('Status'), width: 250, isSortable: true },
    ];
    const [tableRows, setTableRows] = useState<any[]>([]);
    const [data, setData] = useState<RecordModel<any>>();

    const fetchDataForPage = async (pageNumber: any) => {
        // Fetch data for the specified page from the backend
        const data = await getScheduleListQuery(
            {
                locationId: position?.id,
                page: pageNumber
            }
        );
        if (data.status === 'fulfilled') {
            return data.data.records.map((item: any) => ({
                id: item.ScheduleId,
                scheduleStartTime: item.scheduleStartTime,
                scheduleEndTime: item.scheduleEndTime,
                date: item.scheduleWorkDate,
                status: item.scheduleStatus,
            }))
        }
        // return [];
    };
    useEffect(() => {
        getScheduleListQuery({
            locationId: position?.id
        })
            .then((schedule: any) => {
                if (schedule.status == 'fulfilled') {
                    //console.log("getScheduleQuery", schedule?.data)
                    const tableRows = schedule?.data.records.map((item: any) => ({
                        id: item.ScheduleId,
                        scheduleStartTime: item.scheduleStartTime,
                        scheduleEndTime: item.scheduleEndTime,
                        date: item.scheduleWorkDate,
                        status: t(item.scheduleStatus),

                    }))
                    setTableRows(tableRows)
                    setData(schedule?.data)
                }
            })
        // .then((respone: any) => respone?.data?.records)
        //     .then((d: any) => {
        //         console.log("d", d);
        //     })
        // .then(() => console.log("scheduleList", scheduleList))
    }, [])

    const handleRowClick = (entry: any) => {
        // Handle the row click event and pass the row value to another page or component
        //console.log("entry", entry)
        // navigate('/add-work-schedule', { state: { entry } });
        if (entry?.status == "pending" && permissions.includes(Permissions.EntryEdit))
            navigate('/add-work-schedule', { state: { project: project, position: position, entry: entry } });
        else
            navigate('/entry-detail', { state: { project: project, location: position, entry: entry } });
    };

    const permissions = useSelector(selectPermissions)
    return (
        <MainContent type={projectPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <LightBlueContainer>
                    <BigHeading>{t("Work Schedule")}</BigHeading>

                    {
                        permissions.includes(Permissions.EntryEdit)
                        && <ShortBlueButton onClick={() => { navigate('/add-work-schedule', { state: { project: project, position: position } }) }}>{t("Add New Schedule")}</ShortBlueButton>
                    }

                    {/* <RecordTable columns={columns} rows={tableRows} checkbox={false} onClick={handleRowClick} pages={page}></RecordTable> */}
                    <RecordTableV2
                        columns={columns}
                        rows={tableRows}
                        checkbox={false}
                        pages={data?.totalPages}
                        totalCount={data?.totalCount}
                        onClick={handleRowClick}
                        updateTableRows={setTableRows}
                        fetchDataForPage={fetchDataForPage}
                    ></RecordTableV2>
                    &nbsp;
                </LightBlueContainer>
            </BackgroundStyle>
        </MainContent>
    );
};

export default WorkSchedulePage;